<div class="map-container">
  <rqa-map-toolbar [filterLayerTypes]="filterLayerTypes()"></rqa-map-toolbar>
  <div class="airspace-info">
    <p-accordion [styleClass]="'box-accordion'" [value]="activeAccordionIndex()" (onOpen)="onAccordionOpen($event)">
      @for (layer of selectedLayers; track trackByFn($index, layer)) {
        <p-accordion-panel [ngClass]="{ 'region-disabled': layer.type === 'SECTOR' }" [id]="layer.id" [value]="$index">
          <ng-container *ngIf="layer.type !== 'SECTOR'; else sector">
            <p-accordion-header><rqa-airspace-info [airspaceInfo]="layer"></rqa-airspace-info></p-accordion-header>
            <p-accordion-content>
              <rqa-airspace-table
                [type]="layer.type"
                [availabilities]="layer.availabilities"
                [designator]="layer.designator"
              ></rqa-airspace-table>
            </p-accordion-content>
          </ng-container>
          <ng-template #sector>
            <p-accordion-header><rqa-airspace-info [airspaceInfo]="layer"></rqa-airspace-info></p-accordion-header>
          </ng-template>
        </p-accordion-panel>
      }
    </p-accordion>
  </div>
  <div
    id="map"
    [style.height.px]="contentHeight()"
    leaflet
    [leafletOptions]="options"
    (leafletMapReady)="onMapReady($event)"
    (leafletClick)="onMapClick($event)"
  ></div>
  @if (showFilters()) {
    <div class="height-container">
      <rqa-map-height
        [filterHeightRange]="heightRange"
        (heightRangeChange)="onHeightRangeChange($event)"
      ></rqa-map-height>
    </div>
  }
</div>
